import {
  GET_AUCTION,
  GET_AUCTION_BY_ID,
  GET_AUCTION_MINE,
  GET_MINE_AUCTION_ORDER_DETAILS,
  GET_AUCTION_ORDER_DETAILS,
  GET_FILTERD_AUCTION,
  GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS,
} from "../constants/index";

export const auction = (
  state = {
    getauctionlist: [],
    getauctionbyid: {},
    getmineauctionlist: [],
    getfilterdaction: {},
    autionmineorderlist: {},
    activeautionmineorderlist:{}
  },
  action
) => {
  switch (action.type) {
    case GET_AUCTION:
      return { ...state, getauctionlist: action.getauctionlist };
    case GET_AUCTION_MINE:
      return { ...state, getmineauctionlist: action.getmineauctionlist };
    case GET_AUCTION_BY_ID:
      return { ...state, getauctionbyid: action.getauctionbyid };
    case GET_FILTERD_AUCTION:
      return { ...state, getfilterdaction: action.getfilterdaction };
      case GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS:
        return { ...state, activeautionmineorderlist: action.activeautionmineorderlist };
    case GET_MINE_AUCTION_ORDER_DETAILS:
      return {
        ...state,
        autionmineorderlist: action.autionmineorderlist,
      };
    case GET_AUCTION_ORDER_DETAILS:
      return {
        ...state,
        autionorderlist: action.autionorderlist,
      };
    default:
      return state;
  }
};
